'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('babel-polyfill');

var _githubApi = require('github-api');

var _githubApi2 = _interopRequireDefault(_githubApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Gitchat = function () {
  function Gitchat(username, password, repo) {
    _classCallCheck(this, Gitchat);

    this.gh = new _githubApi2.default({ username: username, password: password });
    this.repo = this.gh.getRepo(username, repo);
  }

  _createClass(Gitchat, [{
    key: 'getAllCommits',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(branch) {
        var options;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = {
                  sha: branch
                };
                _context.next = 3;
                return this.repo.listCommits(options);

              case 3:
                return _context.abrupt('return', _context.sent.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllCommits(_x) {
        return _ref.apply(this, arguments);
      }

      return getAllCommits;
    }()
  }, {
    key: 'getAllCommitMessages',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(branch) {
        var commits, commitMessages;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getAllCommits(branch);

              case 2:
                commits = _context2.sent;
                commitMessages = commits.map(function (commitObject) {
                  return commitObject.commit.message;
                });
                return _context2.abrupt('return', commitMessages);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAllCommitMessages(_x2) {
        return _ref2.apply(this, arguments);
      }

      return getAllCommitMessages;
    }()
  }, {
    key: 'getAllBranches',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.repo.listBranches();

              case 2:
                _context3.sent.data;

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllBranches() {
        return _ref3.apply(this, arguments);
      }

      return getAllBranches;
    }()
  }, {
    key: 'getBranch',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(branchName) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.repo.getBranch(branchName);

              case 2:
                _context4.sent.data;

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getBranch(_x3) {
        return _ref4.apply(this, arguments);
      }

      return getBranch;
    }()
  }, {
    key: 'commit',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(branchName, message) {
        var options;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = {
                  shouldEncode: false
                };
                _context5.next = 3;
                return this.repo.writeFile(branchName, 'README.md', '', message, options);

              case 3:
                return _context5.abrupt('return', _context5.sent);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function commit(_x4, _x5) {
        return _ref5.apply(this, arguments);
      }

      return commit;
    }()
  }, {
    key: 'sendChatMessage',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(channelName, message) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.commit(channelName, message);

              case 2:
                return _context6.abrupt('return', _context6.sent);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendChatMessage(_x6, _x7) {
        return _ref6.apply(this, arguments);
      }

      return sendChatMessage;
    }()
  }, {
    key: 'getMessagesFromChannel',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(channelName) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getAllCommitMessages(channelName);

              case 2:
                return _context7.abrupt('return', _context7.sent);

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getMessagesFromChannel(_x8) {
        return _ref7.apply(this, arguments);
      }

      return getMessagesFromChannel;
    }()
  }]);

  return Gitchat;
}();

exports.default = Gitchat;


//////////////////
// WEBPACK FOOTER
// ./node_modules/gitchat/lib/index.js
// module id = 286
// module chunks = 0